import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {RootState} from "../../redux/store";
import {VeneCard} from "../../Atoms/VeneCard";
import {useQuery} from "@apollo/client";
import {GetAdventureById} from "../../GraphQL/AdventureQueries";
import {useEffect} from "react";
import {setActiveContent, setIsAppLoading} from "../../redux/slices/content/contentSlice";
import {toast} from "react-toastify";
import Button from "../../Atoms/Button";
import {setAdventure} from "../../redux/slices/adventure/adventureSlice";
import {ActiveContent} from "../../redux/slices/content/contentType";

export const Dashboard = () => {
    const user = useAppSelector((state: RootState) => state.user);
    const dispatch = useAppDispatch();
    
    const { data: lastPlayedData, loading: lastPlayedLoading, error: lastPlayedError} = useQuery(GetAdventureById, {
        variables: {
            adventureId: user.lastPlayedAdventure
        },
        skip: user.lastPlayedAdventure === 0
    });

    const { data: lastHostedData, loading: lastHostedLoading, error: lastHostedError} = useQuery(GetAdventureById, {
        variables: {
            adventureId: user.lastHostedAdventure
        },
        skip: user.lastHostedAdventure === 0 || user.role < 2
    });

    useEffect(() => {
        if (lastPlayedLoading || lastHostedLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: "Lade die letzten Abenteuer"}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ""}))
        }
    }, [ lastPlayedLoading, lastHostedLoading ]);

    useEffect(() => {
        if (lastHostedError) {
            toast("Fehler beim Laden des letzten gehosteten Abenteuers")
        }
        
        if (lastPlayedError) {
            toast("Fehler beim Ladend es letzten gespielten Abenteuers")
        }
    }, [lastHostedError, lastHostedError]);


    const loadLastPlayedAdventure = () => {
        if (lastPlayedData) {
            const adventure = lastPlayedData.getAdventureById;
            dispatch(setAdventure({
                adventureId: adventure.adventureId,
                adventureDesc: adventure.adventureDescription,
                adventureName: adventure.adventureName,
                user_to_adventure: []
            }))
            dispatch(setActiveContent(ActiveContent.KampagnePlay))
        }
    }
    
    const renderLastPlayedCardBody = () => {
        if (user.lastPlayedAdventure !== 0 && lastPlayedData) {
            return (
                <div className="vene-dashboard-lastPlayed-content">
                    <div className="vene-dashboard-lastPlayed-header">
                        Setze dort fort wo du aufgehört hast:
                    </div>
                    <div className="vene-dashboard-lastPlayed-body">
                        {lastPlayedData.getAdventureById.adventureName}
                    </div>
                    <div className="vene-dashboard-lastPlayed-footer">
                        <Button onClick={() => loadLastPlayedAdventure()}>
                            Starten
                        </Button>
                    </div>
                </div>
            )
        }

        return (
            <div>
                Starte ein neues Pen and Paper im Reiter "Kampagne" !
            </div>
        )
    }
    
    const loadLastHostedAdventure = () => {
        if (lastHostedData) {
            const adventure = lastHostedData.getAdventureById
            dispatch(setAdventure({
                adventureId: adventure.adventureId,
                adventureDesc: adventure.adventureDescription,
                adventureName: adventure.adventureName,
                user_to_adventure: adventure.user_to_adventure
            }))
            dispatch(setActiveContent(ActiveContent.AdventureMask))
        }
    }

    const renderLastHostedCardBody = () => {
        if (user.lastHostedAdventure !== 0 && lastHostedData) {
            return (
                <div className="vene-dashboard-lastPlayed-content">
                    <div className="vene-dashboard-lastPlayed-header">
                        Plane eine neue Runde in deiner letzten geleiteten Kampagne:
                    </div>
                    <div className="vene-dashboard-lastPlayed-body">
                        {lastHostedData.getAdventureById.adventureName}
                    </div>
                    <div className="vene-dashboard-lastPlayed-footer">
                        <Button onClick={() => loadLastHostedAdventure()}>
                            Starten
                        </Button>
                    </div>
                </div>
            )
        }

        return (
            <div>
                Starte ein neues Pen and Paper im Reiter "Abenteuer" !
            </div>
        )
    }

    return (
        <div className="vene-dashboard-container">
            <div>
                <h3>Willkommen {user.userName} auf dem Dashboard</h3>
            </div>
            <div className="vene-dashboard-content">
                <VeneCard cardHeader="Letztes Abenteuer">
                    { renderLastPlayedCardBody() }
                </VeneCard>
                { user.role > 1 &&
                    <VeneCard cardHeader="Spielleiter">
                        { renderLastHostedCardBody() }
                    </VeneCard>
                }
            </div>
        </div>
    )
}